import SummaryPage from './summary/SummaryPage';
import MultiTenantPage from './multi-tenant/MultiTenantPage';
import { GoogleFonts, GlobalTheme } from './';

export default {
  path: 'on-boarding/:version/v',
  name: 'On boarding',
  childRoutes: [
    {
      path: ':projectId',
      name: 'Default page',
      component: GlobalTheme,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/multi-tenant',
      name: 'MultiTenant page',
      component: MultiTenantPage,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/summary',
      name: 'Summary page',
      component: SummaryPage,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/custom-fonts',
      name: 'Google fonts',
      component: GoogleFonts,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/global-theme',
      name: 'Global Theme',
      component: GlobalTheme,
      isIndex: true,
      isPrivate: true,
    },
  ],
};
